export class Maestro_Consultas {
    id: number;
    nombreConsulta: string;
    descripcionConsulta: string;
    idTipoConsulta: number;
    descripcionTipoConsulta: string;
    queryEjecutar: string;
    activo: boolean;
    aplicacionesSeleccionada: number[];
    rolesSeleccionados: number[];
    usuariosSeleccionados: number[];
    columnaTotalizar: string;
    tipoExportacion: string;
    extensionArchivoPlano: string;
    separadorArchivoPlano: string;
    queryExportar: string;
}
